import Typography from "Components/CommonComponents/Typography";
import React from "react";
import "./index.css";
import cx from "classnames";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { SegmentMapping } from "utilFunctions/Constants/Constants";
import ArrowUpRightBlack from "Assets/Icons/ArrowUpRightBlackIcon";
import InfoIcon from "Assets/Icons/InfoIcon";
import CustomTooltip from "Components/CommonComponents/CustomTooltip";

interface IBranchHeader {
  aggregatedDataLoading?: boolean;
  aggregatedData?: any;
  mode?: string;
  filterState?: any;
  onHandleSegmentSelection?: any;
}

function BranchHealthHeader({
  aggregatedDataLoading,
  aggregatedData,
  mode,
  filterState,
  onHandleSegmentSelection,
}: IBranchHeader) {
  const { screen }: any = useWindowSize();

  const renderName = (item: any) => {
    switch (item) {
      case "totalBranch":
        return "Total";
      case "totalActiveStudents":
        return "Total";
      case "active":
        return "Active";
      case "moderateRisk":
        return "MODERATE";
      case "highRisk":
        return "HIGH";
      case "alarmingRisk":
        return "ALARMING";
      case "followUpCount":
        return "Followed Up";
    }
  };
  const renderLabelName = (item: any) => {
    switch (item) {
      case "totalBranch":
        return "Branch";
      case "totalActiveStudents":
        return "Students";
      case "active":
        return "Students";
      case "moderateRisk":
        return "Risk";
      case "highRisk":
        return "Risk";
      case "alarmingRisk":
        return "Risk";
      case "followUpCount":
        return "Students";
    }
  };

  const handleSegmentSelection = (selected: any) => {
    onHandleSegmentSelection(selected);
  };
  const checkHeaderColor = (filters: any, label: any) => {
    if (
      filters?.segment != null &&
      SegmentMapping[filters?.segment?.label] == label
    ) {
      return true;
    } else {
      return false;
    }
  };

  const returnHeaderContentColor = (item: any) => {
    let cssStyle = "headerContent";
    if (item == "moderateRisk") {
      cssStyle = "headerSelectedContentModerate";
    } else if (item == "highRisk") {
      cssStyle = "headerSelectedContentHigh";
    } else if (item == "alarmingRisk") {
      cssStyle = "headerSelectedContentAlarming";
    } else {
      cssStyle = "headerStudentContent";
    }
    return cssStyle;
  };
  const renderCustomTooltip = (item: any) => {
    let cssStyle;
    console.log("itemcssStyle", item);
    if (item == "moderateRisk") {
      cssStyle = (
        <div className="d-flex flex-row justify-content-start align-items-center customTooltipContainer">
          <div className="segmentspan moderateegmentSpan">
            <span>Moderate</span>
          </div>
          <Typography variant="subheading3" color="white">
            {
              "Aakash AI predicts that these students have a notable probability of leaving the institute, but timely help and support could prevent withdrawal. Probability between 50% to 65%"
            }
          </Typography>
        </div>
      );
    } else if (item == "highRisk") {
      cssStyle = (
        <div className="d-flex flex-row justify-content-start align-items-center customTooltipContainer">
          <div className="segmentspan highSegmentSpan">
            <span>High</span>
          </div>
          <Typography variant="subheading3" color="white">
            {
              "Aakash AI predicts that these students will likely leave the institute due to significant challenges, including academic and personal issues. Probability>65%"
            }
          </Typography>
        </div>
      );
    } else if (item == "alarmingRisk") {
      cssStyle = (
        <div className="d-flex flex-row justify-content-start align-items-center customTooltipContainer">
          <div className="segmentspan alarmingSegmentspan">
            <span>Alarming</span>
          </div>
          <Typography variant="subheading3" color="white">
            {
              "Aakash AI anticipates that these students face an alarming risk of leaving the institute, emphasizing the urgent need for immediate support from us. Probability is less than 50% but its increasing since last few months"
            }
          </Typography>
        </div>
      );
    } else {
      cssStyle = (
        <div className="d-flex flex-row justify-content-start align-items-center customTooltipContainer">
          <div className="segmentspan greenSegmentSpan">
            <span>Total</span>
          </div>
          <Typography variant="subheading3" color="white">
            {
              "The count reflects the students included in the Left Out Probability prediction model, not the total number of enrolled students."
            }
          </Typography>
        </div>
      );
    }
    return cssStyle;
  };
  return (
    <>
      <div
        className={cx("headerContentContainer", {
          deskTopViewBranchhealthHeader: ["xxl", "xl", "lg"].includes(screen),
          mobileViewBranchhealthHeader: !["xxl", "xl", "lg"].includes(screen),
        })}
      >
        {!aggregatedDataLoading &&
          aggregatedData &&
          Array.isArray(aggregatedData) &&
          aggregatedData.map((item: { value: any; label: any }, index: any) => {
            return [
              "totalBranch",
              "totalActiveStudents",
              "active",
              "moderateRisk",
              "highRisk",
              "alarmingRisk",
              "followUpCount",
            ].includes(item?.label) ? (
              <div
                className={
                  mode == "studentHome"
                    ? checkHeaderColor(filterState, item?.label)
                      ? returnHeaderContentColor(item?.label)
                      : "headerStudentContent"
                    : "headerContent"
                }
                key={index}
                onClick={() => {
                  if (mode == "studentHome") {
                    handleSegmentSelection(item?.label);
                  }
                }}
              >
                <Typography variant="headingH3" color="black">
                  {item.value && item.value != null && item.value != ""
                    ? item.value
                    : 0}
                </Typography>
                <div className="d-flex flex-row">
                  <Typography
                    variant="h5"
                    color={
                      item.label == "totalActiveStudents"
                        ? "secondary"
                        : item.label == "moderateRisk"
                        ? "yellow"
                        : item.label == "highRisk"
                        ? "red"
                        : item.label == "alarmingRisk"
                        ? "orange"
                        : "black"
                    }
                  >
                    {renderName(item.label)}&nbsp;
                  </Typography>
                  <Typography variant="subheading2" color={"black"}>
                    {renderLabelName(item.label)}
                  </Typography>
                  {mode == "studentHome" &&
                  [
                    "moderateRisk",
                    "highRisk",
                    "alarmingRisk",
                    "followUpCount",
                  ].includes(item?.label) ? (
                    <ArrowUpRightBlack />
                  ) : [
                      "totalActiveStudents",
                      "moderateRisk",
                      "highRisk",
                      "alarmingRisk",
                    ].includes(item?.label) ? (
                    <CustomTooltip
                      content={renderCustomTooltip(item?.label)}
                      direction={
                        item?.label == "alarmingRisk" ? "left" : "left"
                      }
                    >
                      <InfoIcon />
                    </CustomTooltip>
                  ) : null}
                </div>
              </div>
            ) : null;
          })}
      </div>
    </>
  );
}
export default BranchHealthHeader;
